import { api } from './api';

const getQuickAccessLinksGetListWithParam = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `QuickAccessLinks/getList?Page=${pageNumber}&PageSize=${pageSize}`,
        method: 'GET',
        params: body,
    });
    return response.data;
};

const getQuickAccessLinksGetList = () => {
  return getQuickAccessLinksGetListWithParam({});
};

const addQuickAccessLinks = async (data) => {
    const response = await api({
        url: `QuickAccessLinks/add`,
        method: 'POST',
        data: data.entity,
    });
    return response.data;
};

const updateQuickAccessLinks = async (data) => {
    const response = await api({
        url: `QuickAccessLinks/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const deleteQuickAccessLinks = async ({id}) => {
    const response = await api({
        url: `QuickAccessLinks/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const quickAccessLinksServices = {
  getQuickAccessLinksGetList,
  getQuickAccessLinksGetListWithParam,
  addQuickAccessLinks,
  updateQuickAccessLinks,
  deleteQuickAccessLinks,
};

export default quickAccessLinksServices;
